import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'viToDropdownModel',
})
export class ViToDropdownModelPipe implements PipeTransform {
  constructor() {}

  transform(value: Array<any>, ...args: any[]): Array<{ name: string | number; value: string }> {
    let dropdownModel = [];
    if (!Array.isArray(value)) {
      return [];
    }

    const featureName = args[0];

    switch (featureName) {
      case 'circuits':
        dropdownModel = this.convertCircuits(value, args[1]);
        break;
      default:
        dropdownModel = this.convertDefault(value);
        break;
    }

    return dropdownModel;
  }

  private convertCircuits(
    value: Array<string>,
    translation: string
  ): Array<{ name: string; value: string }> {
    const list = [];
    value.forEach((element) => {
      list.push({
        name: `${translation} ${Number(element) + 1}`,
        value: element,
      });
    });

    return list;
  }

  private convertDefault(value: Array<any>): Array<{ name: string; value: string }> {
    const list = [];
    value.forEach((element) => {
      list.push({ name: element, value: element });
    });

    return list;
  }
}
